"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_SCROLL_TOP_DISTANCE = exports.GRID_ROW_HEIGHT = exports.GRID_ROW_GAP = exports.GRID_ITEM_MIN_WIDTH = exports.EXPAND_LESS_ICON = exports.CLOSE_ICON = exports.CATEGORY_ITEM_GAP = exports.ARROW_BACK_ICON = void 0;
var CATEGORY_ITEM_GAP = 16;
exports.CATEGORY_ITEM_GAP = CATEGORY_ITEM_GAP;
var ARROW_BACK_ICON = 'ArrowBackIcon';
exports.ARROW_BACK_ICON = ARROW_BACK_ICON;
var EXPAND_LESS_ICON = 'ExpandLessIcon';
exports.EXPAND_LESS_ICON = EXPAND_LESS_ICON;
var CLOSE_ICON = 'CloseIcon';
exports.CLOSE_ICON = CLOSE_ICON;
var GRID_ROW_HEIGHT = 40;
exports.GRID_ROW_HEIGHT = GRID_ROW_HEIGHT;
var GRID_ROW_GAP = 16;
exports.GRID_ROW_GAP = GRID_ROW_GAP;
var GRID_ITEM_MIN_WIDTH = 150;
exports.GRID_ITEM_MIN_WIDTH = GRID_ITEM_MIN_WIDTH;
var SHOW_SCROLL_TOP_DISTANCE = -200;
exports.SHOW_SCROLL_TOP_DISTANCE = SHOW_SCROLL_TOP_DISTANCE;